import { Avatar, Center, Stack, Text } from "@mantine/core";
import { UserSliceType } from "../../../store/features/authSlice";

const UserAvatar = (props: { user: UserSliceType }) => {
    return(
        <Stack gap={0}>
            <Center>
                <Avatar src={null} size={"lg"} />
            </Center>

            <Center>
                <Text fw={700}>{ `${props.user.name} ${props.user.family_name}` }</Text>
            </Center>

            <Center>
                <Text style={{ opacity: .4 }} fw={300}>{ props.user.email }</Text>
            </Center>
        </Stack>
    )
};

export default UserAvatar;